import { useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./css/Question.module.css";

const Thanks = () => {
	useEffect(() => {
		const t = setTimeout(() => window.open('https://www.ciemradiologos.com', '_self'), 2800);
		return () => clearTimeout(t);
	}, []);

	return (
		<motion.div
			className={styles.containerQuestion}
			initial={{ opacity: 0, scale: 0.92 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ duration: 0.55, ease: [0.32, 0.72, 0, 1] }}
		>
			<motion.div
				initial={{ opacity: 0, y: 12 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ delay: 0.15, duration: 0.4 }}
				style={{ textAlign: "center" }}
			>
				<motion.div
					initial={{ scale: 0, rotate: -20 }}
					animate={{ scale: 1, rotate: 0 }}
					transition={{ delay: 0.25, type: "spring", stiffness: 260, damping: 18 }}
					style={{ fontSize: "2.8rem", marginBottom: "1.25rem" }}
				>
					✓
				</motion.div>

				<div className={styles.titleQuestion}>
					Agradecemos la confianza que nos ha brindado para realizar sus estudios; esperamos atenderle nuevamente.
				</div>

				<motion.div
					style={{
						marginTop: "1.5rem",
						fontSize: "0.82rem",
						color: "#94a3b8",
						letterSpacing: "0.03em",
					}}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.6, duration: 0.5 }}
				>
					Redirigiendo a ciemradiologos.com…
				</motion.div>

				{/* progress bar */}
				<motion.div
					style={{
						marginTop: "0.75rem",
						height: "3px",
						background: "linear-gradient(90deg, #11847d, #48c1ba)",
						borderRadius: "99px",
						originX: 0,
					}}
					initial={{ scaleX: 0 }}
					animate={{ scaleX: 1 }}
					transition={{ delay: 0.7, duration: 2.0, ease: "linear" }}
				/>
			</motion.div>
		</motion.div>
	);
};

export default Thanks;
